import * as React from 'react'
import { Text, View } from 'react-native'

const GradientText = (props) => <Text style={props.style}>{props.label}</Text>
export { GradientText }
